export function otaSettlementChannel(channel: string | null | undefined): string | null {
  if (!channel?.trim()) return null;
  const key = channel.trim().toLowerCase();
  if (key === 'bookingcom' || key === 'booking.com') return 'Booking.com';
  if (key === 'airbnb') return 'Airbnb';
  return 'unknown';
}
